import moment from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Highlighter from 'react-highlight-words';
import { MdPersonOutline } from 'react-icons/md';

import StickyTable from '../../../components/Tables/StickyTable';
import { getAuth, getUserSource } from '../../../redux/selectors';

import { getLrsUserPrimaryPhone } from '../../../utility/helpers/utils';
import LrsContactRepository from '../../../repositories/LrsContactRepository';
import { useHistory } from 'react-router-dom';

const SearchLawyerContacts = ({ searchCriteria }) => {
    const history = useHistory();
    const sourceId = useSelector(getUserSource);
    const { loggedUser } = useSelector(getAuth);
    const [searchParams, setSearchParams] = useState({
        page: 0,
        pageCount: 5,
    });
    const [loading, setLoading] = useState(false);
    const [contacts, setContacts] = useState({
        loaded: false,
        list: [],
        totalCount: 0,
    });

    const getClients = async (userId, searchParams) => {
        setLoading(true);

        const result = await LrsContactRepository.getLrsContactsByLawyer(
            userId,
            searchParams,
        );
        if (result.data.success) {
            setContacts({
                loaded: true,
                list: result.data.data.list,
                totalCount: result.data.data.total,
            });
        }
        setLoading(false);
    };

    useEffect(() => {
        let payload = {
            sourceId: sourceId,
            searchCriteria: searchCriteria,
            pageCount: searchParams.pageCount,
            page: searchParams.page,
        };

        getClients(loggedUser.id, payload);
    }, [
        searchCriteria,
        searchParams.page,
        searchParams.pageCount,
        sourceId,
        loggedUser.id,
    ]);

    const columns = useMemo(() => {
        return [
            {
                Header: 'Name',
                id: 'fullName',
                accessor: (originalRow) => originalRow,
                Cell: ({ value }) => {
                    return (
                        <Highlighter
                            searchWords={[`${searchCriteria}`]}
                            autoEscape={true}
                            textToHighlight={`${value?.firstName || ''} ${
                                value?.lastName || ''
                            }`}
                            highlightTag="strong"
                        />
                    );
                },
            },
            {
                Header: 'Primary - Phone',
                id: 'phoneNumber',
                accessor: (originalRow) => originalRow,
                Cell: ({ value }) => {
                    return getLrsUserPrimaryPhone(value);
                },
            },
            {
                Header: 'Email',
                accessor: 'emailAddress',
                Cell: ({ value }) => {
                    return (
                        <Highlighter
                            searchWords={[`${searchCriteria}`]}
                            autoEscape={true}
                            textToHighlight={value}
                            highlightTag="strong"
                        />
                    );
                },
            },
            {
                Header: 'Created',
                accessor: 'created',
                Cell: ({ value }) => {
                    return moment(value).format('MM-DD-YYYY');
                },
            },
        ];
    }, [searchCriteria]);

    const formatTrProps = (state = {}) => {
        return {
            onClick: () => {
                history.push(`/contact/${state.original.id}`);
            },
            style: {
                cursor: 'pointer',
            },
        };
    };

    if (!loading && contacts.loaded && contacts.totalCount === 0) {
        return null;
    }

    return (
        <div className="mb-5">
            <h4 className="q-fw-500 d-flex align-items-center mb-0">
                <MdPersonOutline size={24} color="#5A5A5A" className="me-1" />
                Clients
            </h4>

            <StickyTable
                columns={columns}
                data={contacts.list}
                isSubComponent={false}
                renderRowSubComponent={() => {}}
                pageCount={Math.ceil(
                    contacts.totalCount / searchParams.pageCount,
                )}
                handleSearch={(name, value) => {
                    setSearchParams((prevState) => {
                        return {
                            ...prevState,
                            [name]: value,
                        };
                    });
                }}
                isLoading={loading}
                wrapperStyles={{
                    minHeight: '100px',
                    position: 'relative',
                }}
                formatRowProps={(state) => formatTrProps(state)}
            />
        </div>
    );
};

export default SearchLawyerContacts;
